import { twoDigits } from "./numberUtils";

export const getToday = (): Date => {
  return new Date();
};

export const countDays = (month: number, year: number): number => {
  return new Date(year, month + 1, 0).getDate();
};

export const parseDate = (dateString: string): Date => {
  return new Date(dateString);
};

export const formatDate = (
  day: number,
  month: number,
  year: number,
): string => {
  const date = new Date(year, month, day);
  return `${date.getFullYear()}-${twoDigits(date.getMonth() + 1)}-${twoDigits(
    date.getDate(),
  )}`;
};

export const getWeekNumber = (date: Date): number => {
  const clonedDate = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
  );

  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  clonedDate.setUTCDate(
    clonedDate.getUTCDate() + 4 - (clonedDate.getUTCDay() || 7),
  );

  // Calculate full weeks to nearest Thursday
  const yearStart = new Date(Date.UTC(clonedDate.getUTCFullYear(), 0, 1));
  const oneDayInMs = 86400000;

  return Math.ceil(
    ((clonedDate.getTime() - yearStart.getTime()) / oneDayInMs + 1) / 7,
  );
};

export const getWeekNumbers = (month: number, year: number): number[] => {
  const weekNumbers: number[] = [];

  for (let i = 1; i <= countDays(month, year); i++) {
    let weekNumber = getWeekNumber(new Date(year, month, i));

    if (month === 11 && weekNumber === 1) {
      weekNumber = weekNumbers[weekNumbers.length - 1] + 1;
      weekNumbers.push(weekNumber);
      break;
    }

    weekNumbers.push(weekNumber);
  }

  return Array.from(new Set(weekNumbers));
};

export const getMonthName = (month: number, lang: string): string => {
  const date = new Date(2000, month, 1);
  return date.toLocaleString(lang, { month: "long" });
};
